/*-----------------------------------------------------------------
- Api Market
-----------------------------------------------------------------*/

export default {
    title     : 'Api Market',
    learn_more: 'Read more',
};
